import { render, staticRenderFns } from "./VersionHistoryItem.vue?vue&type=template&id=5df36871"
import script from "./VersionHistoryItem.vue?vue&type=script&lang=ts"
export * from "./VersionHistoryItem.vue?vue&type=script&lang=ts"
import style0 from "./VersionHistoryItem.vue?vue&type=style&index=0&id=5df36871&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports